var decycle = require("cycle").decycle;

module.exports = {
	log: log,
	logState: logState
};

function log(self, event, data){
	self.emit("$mqtt:$/bluetooth/" + event, decycle(data));
}

function logState(self, event, data){
	log(self, event, getPrivate(data));
}

function getPrivate(obj){
	return Object.keys(obj).reduce((result, key) => {
		if(key.startsWith("_"))
			result[key] = obj[key];
		return result;
	}, {});
}